import type { ReactNode } from "react";
import { Avatar } from "@/components/shared/Avatar";
import type { Channel } from "@/lib/chat-room/channels";

const MAX_AVATARS = 6;

interface ChatChannelHeaderProps {
  channel: Channel;
  members: { user_id: string; full_name: string | null; avatar_url: string | null }[];
  /** Brikker og knapper til høyre (prosjektlenke, oppsummering). */
  actions?: ReactNode;
}

/** Toppen av en åpen kanal: navn, medlemmer og handlinger. */
export function ChatChannelHeader({ channel, members, actions }: ChatChannelHeaderProps) {
  const shown = members.slice(0, MAX_AVATARS);
  const rest = members.length - shown.length;
  return (
    <div className="flex flex-wrap items-center gap-2.5 border-b-[1.5px] border-border px-5 py-3.5">
      <h2 className="font-display text-[19px] font-semibold tracking-[-0.02em]">{channel.title}</h2>
      {members.length > 0 && (
        <div className="flex items-center pl-1.5" aria-label={`${members.length} medlemmer`}>
          {shown.map((m, i) => (
            <Avatar
              key={m.user_id}
              name={m.full_name}
              avatarUrl={m.avatar_url}
              size="sm"
              className={i > 0 ? "-ml-2 ring-[1.5px] ring-card" : "ring-[1.5px] ring-card"}
            />
          ))}
          {rest > 0 && <span className="ml-1.5 text-xs text-muted-foreground">+{rest}</span>}
        </div>
      )}
      {actions && <div className="ml-auto flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
